/*
 * Connecting to StalkerPortal library
 * Borshchov Dimitriy (grimstal@bigmir.net)
 */

"use strict";
import {AuthObject, ChannelObject, InitObject, RequestParams} from "./objects";
import * as cookieParams from '../constants/cookies';
import {StalkerParser, M3UParser} from "./parsers";
import {getlog} from "./type_checker";
import $ from "jquery";
import moment from "moment-timezone";
import Cookies from "js-cookie";
import { identify, Identify, setUserId, init, track } from '@amplitude/analytics-browser';
import { AmplitudeKey } from '../config';

export function StalkerClient() {

    this._authData = null;
    this._AuthURL = "https://tv.briz.ua/api/auth";
    this._DataURL = "//tv.briz.ua/api/users/";
    this._userActivityTimer = null;
    this.userActivityTimerUpdateInterval = 2 * 60 * 1000;
    this._inited = false;
    this._login = '';
    this._password = '';
    this._mac = null;
    this.isSendUserActivity = false;

    this.init = function () {
        var self = this;
        var checkInit = $.Deferred();

        if (typeof (InitObject) !== 'function') {
            checkInit.reject('load InitObject library first');
            return checkInit.promise();
        }

        if (typeof (AuthObject) !== 'function') {
            checkInit.reject('load AuthObject library first');
            return checkInit.promise();
        }

        if (typeof (StalkerParser) !== 'function') {
            checkInit.reject('load Parser library first');
            return checkInit.promise();
        }

        this.parser = new StalkerParser();
        this._authData = new AuthObject();

        var storedAuthData = this.getAuthDataStored();
        if (storedAuthData) {
            this.setAuthData(storedAuthData);
        }

        self._inited = true;

        return checkInit.promise();
    };

    this.withSendUserActivity = function(){
        this.isSendUserActivity = true;
    };

    this.login = function (initObject) {

        var checkInit = $.Deferred();

        this._mac = initObject.mac;
        this._login = initObject.login;
        this._password = initObject.password;

        this._loginUser().then(
            function (data) {
                checkInit.resolve("Init done");
            },
            function (data) {
                checkInit.reject(data);
            });

        return checkInit.promise();
    };

    this.isLogin = function () {
        return this._authData.isLogin();
    };

    this.setAuthData = function (authData) {
        this._authData.set(authData);
    };

    this.clearAuthData = function () {
        this.clearData();
    };

    this.getAuthDataStored = function () {
        let store = Cookies.get(cookieParams.AUTH_DATA);

        if (store === undefined) {
            return false;
        }

        return JSON.parse(store);

    };

    this.cleanAuthDataStored = function () {
        Cookies.remove(cookieParams.AUTH_DATA);
    };

    this.saveAuthData = function (data) {
        let strData = JSON.stringify(data);
        Cookies.set(cookieParams.AUTH_DATA, strData, cookieParams.cookieOptions);
    };

    this.clearData = function () {
        if (this._authData !== null) {
            this._authData.clear();
        }

        return true;
    };

    this.logout = function () {

        var df = $.Deferred();

        this.stopSendUserActivity();
        this.clearData();
        this.cleanAuthDataStored();
        df.resolve(true);

        return df.promise();

    };

    this._setAjaxRequest = function (RequestParams) {
        var df = $.Deferred();

        $.ajax({
            type: RequestParams.restMethod,
            url: RequestParams.url,
            dataType: RequestParams.dataType,
            data: RequestParams.data,
            crossDomain: (RequestParams.crossDomain != undefined) ? RequestParams.crossDomain : false,
            headers: RequestParams.headers,
            timeout: (RequestParams.timeout != undefined) ? RequestParams.timeout : 5000,
            success: function (data) {
                RequestParams.successFunction(data);
                df.resolve(data);
            },
            error: function (data) {
                RequestParams.errorFunction(data);
                df.reject(data);
            }
        });

        return df.promise();
    };

    this._lookForLogin = function () {
        var status = $.Deferred();

        if (!this._inited) {
            status.reject('Not inited');
            return status.promise();
        }

        if (this._authData.isLogin() === false) {
            if (this._authData.refreshToken !== null) {
                this._refreshToken().then(
                    function (data) {
                        status.resolve(data);
                    },
                    function (data) {
                        status.reject(data);
                    });
            } else {
                this._loginUser().then(
                    function (data) {
                        status.resolve(data);
                    },
                    function (data) {
                        status.reject(data);
                    });
            }

        } else {
            status.resolve('Sucessful');
        }

        return status.promise();
    };

    this._sendAuthorizationRequest = function (request_data) {
        var self = this;
        var status = $.Deferred();
        var error;
        var request;

        if (typeof RequestParams !== 'function') {
            status.reject("load RequestParams library first");
            return status.promise();
        }

        function successFunc(data) {
            if (data) {
                self._authData.set(data);
                if (self._authData.isLogin() === true) {

                    if (self.isSendUserActivity){
                        self._updateUserActivity();
                    }

                    self.saveAuthData(data);
                    status.resolve(data);
                } else if (data.error_description) {
                    status.reject(data.error_description);
                } else {
                    status.reject(data);
                }
            } else {
                status.reject("Unknown mistake");
            }
        }

        function errorFunc(data) {
            clearTimeout(self._userActivityTimer);
            if (data) {
                if (data.responseJSON && data.responseJSON.error) {
                    error = data.responseJSON.error;
                } else {
                    error = "Server doesn't answer";
                }
            } else {
                error = "Unknown mistake";
            }
            status.reject(error);
        }

//        window.Iptv.setEventInfo("Авторизация", '#c9c827');
        getlog("Авторизация");
        request = new RequestParams();
        request.setRequest("POST", this._AuthURL, successFunc, errorFunc);
        request.setDataType("json");
        request.setHeaders({"Content-Type": "application/x-www-form-urlencoded"});
        request.setCrossDomain(true);
        if (request_data) {
            request.setData(request_data);
        }
        this._setAjaxRequest(request);

        return status.promise();
    };

    this._sendActivityRequest = function (rest_url, RestMethod, ContentType, Data) {
        var self = this;
        var result = $.Deferred();
        var url;
        var request;
        var error;

        if (!rest_url || !RestMethod) {
            result.reject(false);
            return result.promise();
        }

        if (typeof RequestParams !== 'function') {
            result.reject("load RequestParams library first");
            return result.promise();
        }

        function successFunc(data) {
            if (data.status && data.status === 'OK') {
                result.resolve("Activity request done");
            } else {
                result.reject('Activity request failed');
            }

        }

        function errorFunc(data) {
            if (data) {
                if (data.responseJSON && data.responseJSON.error) {
                    error = data.responseJSON.error;
                } else {
                    error = "Activity request failed";
                }
            } else {
                error = 'Activity request failed';
            }
            result.reject(error);
        }

        this._lookForLogin().then(
            function () {
                url = self._DataURL + self._authData.userID + rest_url;
                request = new RequestParams();
                request.setRequest(RestMethod, url, successFunc, errorFunc);
                request.setDataType("json");
                request.setHeaders({"Authorization": "Bearer " + self._authData.accessToken, "Content-Type": ContentType});
                request.setCrossDomain(true);
                if (Data) {
                    request.setData(Data);
                }
                self._setAjaxRequest(request);
            },
            function (data) {
                result.reject(data);
            });

        return result.promise();
    };

    this._sendDataRecieveRequest = function (rest_url) {
        var self = this;
        var result = $.Deferred();
        var url;
        var request;
        var error;

        if (typeof (RequestParams) !== 'function') {
            result.reject("load RequestParams library first");
            return result.promise();
        }

        function successFunc(data) {
            if (data.status === 'OK' && data.results) {
                result.resolve(data.results);
            } else {
                result.reject(data);
            }
        }

        function errorFunc(data) {
            if (data) {
                if (data.responseJSON && data.responseJSON.error) {
                    error = data.responseJSON.error;
                } else {
                    error = "Server doesn't answer";
                }
            } else {
                error = "Unknown mistake";
            }

            /** fix for reconnect if access token was generated
             * for another client with same auth data
             * */
            /*
            if (error == "Access token wrong or expired") {
                self._authData.clear();
                self._sendDataRecieveRequest(rest_url).then(
                    function (data) {
                        result.resolve(data);
                    },
                    function (error) {
                        result.reject(error);
                    });
            } else {
                result.reject(error);
            }
            */

            result.reject(error);
        }

        this._lookForLogin().then(
            function () {
                url = self._DataURL + self._authData.userID + rest_url;
                request = new RequestParams();
                request.setRequest("GET", url, successFunc, errorFunc);
                request.setDataType("json");
                request.setCrossDomain(true);
                request.setHeaders({"Authorization": "Bearer " + self._authData.accessToken});
                self._setAjaxRequest(request);
            },
            function (data) {
                result.reject(data);
            });
        return result.promise();
    };

    this._sendFavoritesRequest = function (rest_method, channelID) {
        var self = this;
        var result = $.Deferred();
        var url;
        var request;
        var error;

        if (typeof (RequestParams) !== 'function') {
            result.reject("load RequestParams library first");
            return result.promise();
        }

        if (!rest_method) {
            result.reject("REST method not set");
            return result.promise();
        }

        function successFunc(data) {
            if (data.status === 'OK' && data.results) {
                result.resolve(data.results);
            } else {
                result.reject(data);
            }
        }

        function errorFunc(data) {
            if (data) {
                if (data.responseJSON && data.responseJSON.error) {
                    error = data.responseJSON.error;
                } else {
                    error = "Server doesn't answer";
                }
            } else {
                error = "Unknown mistake";
            }
            /*
            if (error == "Access token wrong or expired") {
                self._authData.clear();
                self._sendFavoritesRequest(rest_method, channelID).then(
                    function (data) {
                        result.resolve(data);
                    },
                    function (error) {
                        result.reject(error);
                    });
            } else {
                result.reject(error);
            }*/
        }

        this._lookForLogin().then(
            function () {
                request = new RequestParams();

                url = self._DataURL + self._authData.userID + "/tv-favorites";

                if (channelID && typeof channelID == "number") {
                    if (rest_method == "DELETE") {
                        url += "/" + channelID;
                    } else {
                        request.setData({"ch_id": channelID});
                    }
                }

                request.setRequest(rest_method, url, successFunc, errorFunc);
                request.setDataType("json");
                request.setCrossDomain(true);
                request.setHeaders({"Authorization": "Bearer " + self._authData.accessToken});
                self._setAjaxRequest(request);
            },
            function (data) {
                result.reject(data);
            });

        return result.promise();
    };

    this._loginUser = function () {
        var data = null;
        var status = $.Deferred();

        if (!this._mac) {
            status.reject('MAC not set');
        } else {
            /** fix to deny access to user with incorrect data
             * In Stalker version 4.9.31 there is bug, which gives access to
             * any user by login not entering password if anything entered in MAC field
             * Borshchov D. 2016/03/21
             */
//            data = "grant_type=password&username=" + this._login + "&password=" + this._password + "&mac=" + this._mac;
            data = "grant_type=password&username=" + this._login + "&password=" + this._password;
            if (this._login.length == 0) {
                data += "&mac=" + this._mac;
            }
            status = this._sendAuthorizationRequest(data);
        }

        return status.promise();
    };

    this._refreshToken = function () {
        var data = null;
        var status = $.Deferred();

        if (!this._authData.refreshToken) {
            status.reject('No refresh token');
        } else {
            data = "grant_type=refresh_token&refresh_token=" + this._authData.refreshToken;
            status = this._sendAuthorizationRequest(data);
        }

        return status.promise();
    };

    this.startSendUserActivity = function () {
        if (this.isSendUserActivity) {
            this._updateUserActivity();
        }
    };

    this.stopSendUserActivity = function() {
        if (this.isSendUserActivity) {
            if (this._userActivityTimer) {
                clearTimeout(this._userActivityTimer);
            }
        }
    };

    this._updateUserActivity = function () {
        var self = this;

        if (this._userActivityTimer) {
            clearTimeout(this._userActivityTimer);
        }

        this._sendActivityRequest("/ping", "GET").then(
            function (response) {
                getlog("User activity: " + response);
                self._userActivityTimer = setTimeout(function () {
                    self._updateUserActivity();
                }, self.userActivityTimerUpdateInterval);
            },
            function (response) {
                getlog("User activity: " + response);
            });
    };

    this._updateUserChannelActivity = function (channelID) {
        this._sendActivityRequest("/media-info", "POST", "application/x-www-form-urlencoded", {"type": "tv-channel", "media_id": channelID}).always(
            function (response) {
                getlog("Update channel activity: " + response);
            });
    };

    this._deleteUserChannelActivity = function () {
        this._sendActivityRequest("/media-info", "DELETE", "application/x-www-form-urlencoded").always(
            function (response) {
                getlog("Delete channel activity: " + response);
            });

    };

    this.getChannels = function (genre_id, onlyFavorite) {
        var self = this;
        var result = $.Deferred();
        var url = '';

        if (!genre_id || genre_id.length == 0) {
            url = '/tv-channels';
        } else {
            url = '/tv-genres/' + genre_id + '/tv-channels';
        }


        if (onlyFavorite) {
            url += "?mark=favorite";
        }

        this._sendDataRecieveRequest(url).then(
            function (data) {
                result.resolve(self.parser.ChannelsArrayParser(data));
            },
            function (data) {
                result.reject(data);
            });

        return result.promise();
    };

    this.initAmlitude = function (data) {
    AmplitudeKey && init(AmplitudeKey, null, { minIdLength: 1 });
    const identifyObj = new Identify();
    console.log(data.fname)
    if (data) {
      setUserId(data.id);
      identifyObj.setOnce('UserName', data.fname);
      identifyObj.setOnce('Account', data.account);
      identifyObj.setOnce('BillinUserId', data.billing_user_id);
      identifyObj.setOnce('UserId', data.id);
    }
    identify(identifyObj);
}

    this.getUserData = function() {
        var self = this;
        var result = $.Deferred();
        var url = '';

        this._sendDataRecieveRequest(url).then(
            function (data) {
               self.initAmlitude(data)
                result.resolve(data);
            },
            function (error) {
                console.log(error);
                result.reject(error);
            }
        );

        return result.promise();
    };

    this.getGenres = function () {

        var self = this;
        var result = $.Deferred();

        var url = '/tv-genres';

        this._sendDataRecieveRequest(url).then(
            function (data) {
                result.resolve(self.parser.GenresArrayParser(data));
            },
            function (data) {
                result.reject(data);
            });

        return result.promise();
    };

    this.getChannelLink = function (ChannelObject) {
        var self = this;
        var result = $.Deferred();
        var chanReg = /[0-9]+/;

        if (!ChannelObject || !ChannelObject.channelID || !chanReg.exec(ChannelObject.channelID)) {
            result.reject('No channelID');
        } else {
//			self._deleteUserChannelActivity();
            var url = '/tv-channels/' + ChannelObject.channelID + '/link';
            result = this._sendDataRecieveRequest(url);
            result.then(function () {
                self._updateUserChannelActivity(ChannelObject.channelID);
            });
        }

        return result.promise();
    };

    /**
     * @param {Object} ChannelObject
     * @param {number} amount   -   amount of programms to get including current
     * @returns {unresolved}    -   Programms from current time including
     * current to day end or selected amount
     */
    this.getEPG = function (ChannelObject, amount) {
        var self = this;
        var result = $.Deferred();
        var chanReg = /[0-9]+/;
        var nextAmount;
        var url;

        if (!ChannelObject.tvgName || !chanReg.exec(ChannelObject.tvgName)) {
            result.reject('Channel not selected');
        } else if (!amount || !chanReg.exec(amount)) {
            result.reject('Amount not set');
        } else {
            nextAmount = "?next=" + amount;
            url = '/tv-channels/' + ChannelObject.tvgName + '/epg' + nextAmount;
            this._sendDataRecieveRequest(url).then(
                function (data) {
                    result.resolve(self.parser.EPGArrayParser(data, ChannelObject.tvgName));
                },
                function (data) {
                    result.reject(data);
                });
        }

        return result.promise();
    };

    this.getEPGForDate = function (ChannelObject, date) {
        var self = this;
        var result = $.Deferred();
        var chanReg = /[0-9]+/;
        var selectedDate;
        var nextDate;

        if (!ChannelObject.tvgName || !chanReg.exec(ChannelObject.tvgName)) {
            result.reject('Channel not selected');
        } else if (!date) {
            result.reject('Date not selected');
        } else {
            selectedDate = moment(date).tz("Europe/Kiev").startOf('day').unix();
            nextDate = moment.unix(selectedDate).tz("Europe/Kiev").add(1, 'days').unix();

            var url = '/tv-channels/' + ChannelObject.tvgName + '/epg?from=' + selectedDate + '&to=' + nextDate;

            this._sendDataRecieveRequest(url).then(
                function (data) {
                    result.resolve(self.parser.EPGArrayParser(data, ChannelObject.tvgName));
                },
                function (data) {
                    result.reject(data);
                });

        }

        return result.promise();
    };

    this.addFavorite = function (channelObj) {
        var result = $.Deferred();

        if (typeof ChannelObject != "function") {
            result.reject("load ChannelObject library first");
            return result.promise();
        }

        if (!channelObj) {
            result.reject("channel not set");
            return result.promise();
        }

        this._sendFavoritesRequest("POST", channelObj.channelID).then(
            function (data) {
                result.resolve(true);
            },
            function (data) {
                result.reject(data);
            });

        return result.promise();
    };

    this.deleteFavorite = function (channelObj) {
        var result = $.Deferred();

        if (typeof ChannelObject != "function") {
            result.reject("load ChannelObject library first");
            return result.promise();
        }

        if (!channelObj) {
            result.reject("channel not set");
            return result.promise();
        }

        this._sendFavoritesRequest("DELETE", channelObj.channelID).then(
            function () {
                result.resolve(true);
            },
            function (data) {
                result.reject(data);
            });

        return result.promise();
    };

    this.dropTimers = function () {
        clearTimeout(this._userActivityTimer);
    };

}


function M3UClient() {

    this._DataURL = null;
    this._epgURL;
    this._inited = false;
    this._epgProgramms = false;

    this.init = function (initer) {
        var checker = $.Deferred();

        if (typeof (M3UParser) !== 'function') {
            checker.reject('load M3UParser library first');
            return checker.promise();
        }

        if (typeof (InitObject) !== 'function') {
            checker.reject('load InitObject library first');
            return checker.promise();
        }

        if (!initer.M3U_url) {
            checker.reject('m3u link is not set');
            return checker.promise();
        }

        this.parser = new M3UParser();
        this._DataURL = initer.M3U_url;

        if (initer.EPG_url) {
            this._epgURL = initer.EPG_url;
        }
        this._inited = true;
        checker.resolve("Init done");

        return checker.promise();
    };

    this.clearData = function () {
        return true;
    };

    this._setAjaxRequest = function (RequestParams) {

        var df = $.Deferred();
        $.ajax({
            type: RequestParams.restMethod,
            url: RequestParams.url,
            dataType: RequestParams.dataType,
            data: RequestParams.data,
            crossDomain: (RequestParams.crossDomain != undefined) ? RequestParams.crossDomain : false,
            headers: RequestParams.headers,
            timeout: (RequestParams.timeout != undefined) ? RequestParams.timeout : 5000,
            success: function (data) {
                RequestParams.successFunction(data);
                df.resolve(data);
            },
            error: function (data) {
                RequestParams.errorFunction(data);
                df.reject(data);
            }
        });
        return df.promise();
    };

    this._sendDataRecieveRequest = function (url) {
        var result = $.Deferred();
        var error;
        var request;

        if (typeof (RequestParams) !== 'function') {
            result.reject("load RequestParams library first");
            return result.promise();
        }

        if (!url) {
            result.reject("URL not selected");
            return result.promise();
        }

        function successFunc(data) {
            result.resolve(data);
        }

        function errorFunc(data) {
            error = "Server doesn't answer";
            result.reject(error);
        }

        request = new RequestParams();
        request.setRequest("GET", url, successFunc, errorFunc);
        request.setCrossDomain(true);
        request.setTimeout(10000);
        this._setAjaxRequest(request);

        return result.promise();
    };

    this.getChannels = function (genre_id) {
        var self = this;
        var result = $.Deferred();

        if (!this._inited) {
            result.reject("You need init() first");
            return result.promise();
        }

        this._sendDataRecieveRequest(this._DataURL).then(
            function (data) {
                var channelsArray = self.parser.ChannelsArrayParser(data, genre_id, self._epgIDs);
                if (channelsArray && channelsArray.length > 0 && channelsArray[0].name != "ПУСТОЙ СПИСОК") {
                    result.resolve(channelsArray);
                } else {
                    result.reject('Channels not received');
                }
            },
            function (data) {
                result.reject(data);
            });
        return result.promise();
    };

    this.getGenres = function () {
        var self = this;
        var result = $.Deferred();

        this.getChannels().then(
            function (channelsContainer) {
                result.resolve(self.parser.GenreArrayParser(channelsContainer));
            },
            function () {
                result.reject("Channels not received");
            });
        return result.promise();
    };

    /**
     * @param {Object} ChannelObject
     * @param {number} amount   -   amount of programms to get including current
     * @returns {unresolved}    -   Programms from current time including
     * current to day end or selected amount
     */
    this.getEPG = function (ChannelObject, amount) {
        var result = $.Deferred();

        result.reject('EPG not available');

        return result.promise();
    };

    this.getEPGForDate = function (ChannelObject, date) {
        var result = $.Deferred();

        result.reject('EPG not available');

        return result.promise();
    };

    this.getChannelLink = function (ChannelObject) {
        var result = $.Deferred();

        if (!ChannelObject || !ChannelObject.URL) {
            result.reject('No channel URL');
        } else {
            result.resolve(ChannelObject.URL);
        }

        return result.promise();
    };

    this.addFavorite = function (channelObj) {
        var result = $.Deferred();
        result.resolve(false);
        return result.promise();
    };

    this.deleteFavorite = function (channelObj) {
        var result = $.Deferred();
        result.resolve(false);
        return result.promise();
    };

    this.dropTimers = function () {
        return false;
    };

}


// WEBPACK FOOTER //
// ./src/api/clients.js